module.exports = __webpack_public_path__ + "static/media/salaryUsers.f9ab823f.svg";